import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  padding-top: calc(var(--space-unit) * 3);
  & > .input {
    display: flex;
    flex-direction: column;
    margin-top: calc(var(--space-unit) * 3);

    & > z-button {
      margin-top: calc(var(--space-unit) * 3);
      margin-bottom: calc(var(--space-unit) * 2);
      width: 100%;
    }
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    padding-top: calc(var(--space-unit) * 5);
    padding-bottom: calc(var(--space-unit) * 6);

    & > .input {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;

      & > z-input {
        width: 100%;
      }

      & > z-button {
        margin-top: unset;
        margin-bottom: unset;
        width: unset;
        margin-left: calc(var(--space-unit) * 2);
      }
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
  }

  /* Desktop wide breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
  }
`;
